module.exports = __webpack_public_path__ + "static/media/wc.8557551d.png";